<template>
  <div class="main-menu card">
    <!-- 🔴 ПЕРВЫЙ ПУНКТ МЕНЮ ОБЯЗАН ОБЪЯСНЯТЬ СЕБЯ (правка 2026-08-25). Он всегда неактивен, и до
         этой подписи новичок видел первым делом серую строку без единого слова о том, почему по ней
         нельзя нажать — соседние турниры при этом честно пишут «откроется после первой партии». -->
    <div class="main-menu__item main-menu__item-inactive">
      {{ $t('menu.campaign') }}
      <span class="main-menu__soon">{{ $t('menu.campaignSoon') }}</span>
    </div>
    <router-link
        to="/pvp"
        class="main-menu__item"
        data-tut="pvp"
    >
      {{ $t('menu.pvp') }}
    </router-link>
    <!-- Задания дня переехали в ПРОФИЛЬ (решение оунера 2026-07-28) — здесь пункта больше нет. -->
    <!-- Мягкий гейтинг (TUTORIAL_PLAN §5): пока новичок не сыграл первую партию, турниры ВИДНЫ,
         но приглушены с подписью «откроется после первой партии» — иначе он уходит с линейного
         пути обучения в раздел, где ему пока нечего делать. -->
    <div
        v-if="lockedForNewbie"
        class="main-menu__item main-menu__item-inactive"
        data-tut="tournaments"
    >
      {{ $t('menu.tournaments') }}
      <span class="main-menu__soon">{{ $tut('tut.lockedHint') }}</span>
    </div>
    <router-link
        v-else
        to="/tournaments"
        class="main-menu__item"
        data-tut="tournaments"
    >
      {{ $t('menu.tournaments') }}
    </router-link>
    <router-link
        to="/options"
        class="main-menu__item"
    >
      {{ $t('menu.options') }}
    </router-link>
    <router-link
        to="/profile"
        class="main-menu__item"
        data-tut="profile"
    >
      {{ $t('menu.profile') }}
      <span v-if="rewardBadge" class="main-menu__badge">{{ rewardBadge }}</span>
    </router-link>
    <!-- Кнопка «Обучение» ВМЕСТО «Вики» (решение оунера): три состояния — идёт / пропущено /
         пройдено («Справка», вики уходит ссылкой внутрь неё). Нажатие возвращает игрока к текущему шагу. -->
    <a
        v-if="tutorialButton"
        href="#"
        class="main-menu__item"
        data-tut="learn"
        @click.prevent="onTutorial"
    >
      {{ tutorialLabel }}
      <span v-if="tutorialButton !== 'help'" class="main-menu__soon">{{ tutorialSub }}</span>
    </a>
    <a
        v-else
        href="https://shedever-studio.gitbook.io/chess-zombies-wpeng/"
        target="_blank"
        class="main-menu__item"
    >
      {{ $t('menu.wiki') }}
    </a>

    <!-- Акт 0, шаг 4: ОДНА карточка про профиль — что это и просьба зайти. Раньше об этом же
         рассказывала остановка экскурсии, и игрок читал два диалога подряд (фидбек оунера). -->
    <TutorialSpotlight
      v-if="tutProfileOpen"
      target="[data-tut='profile']"
      :title="$tut('tut.profileTitle')"
      :text="$tut('tut.profileOpen')"
      :counter="actCounter"
      :next-label="$tut('tut.profileGo')"
      :mentor-icon="mentorIcon"
      :portrait="tutPortrait"
      @next="goProfile"
      @skip="skipTour"
    />
    <!-- Акт 3, шаг 1: наставник встречает вернувшегося игрока и вручает билет колеса.
         Шаг живёт в МЕНЮ, потому что именно сюда игрок попадает при втором заходе. -->
    <TutorialSpotlight
      v-if="tutStep === 'day2_welcome'"
      target="[data-tut='profile']"
      :title="$tut('tut.day2WelcomeTitle')"
      :text="$tut('tut.day2Welcome')"
      :counter="actCounter"
      :next-label="$tut('tut.day2ToDaily')"
      :mentor-icon="mentorIcon"
      :portrait="tutPortrait"
      @next="tutGo('day2_welcome', '/daily')"
      @skip="skipTour"
    />
    <!-- Акт 4, шаг 4: турниры — с ЯВНЫМ предупреждением про отдельный профиль -->
    <TutorialSpotlight
      v-if="tutStep === 'comp_season'"
      target="[data-tut='tournaments']"
      :title="$tut('tut.compSeasonTitle')"
      :text="$tut('tut.compSeason')"
      :counter="actCounter"
      :next-label="$tut('tut.next')"
      :mentor-icon="mentorIcon"
      :portrait="tutPortrait"
      @next="tutGo('comp_season', '/profile')"
      @skip="skipTour"
    />
    <!-- Экскурсия по интерфейсу (Акт 0, шаг 3): подсветка пункта + карточка наставника -->
    <TutorialSpotlight
      v-if="tourStop"
      :target="tourStop.target"
      :title="$t(tourStop.title)"
      :text="$t(tourStop.text)"
      :counter="$tut('tut.stopOf', { n: tourIndex + 1, total: TOUR.length })"
      :next-label="tourIndex + 1 < TOUR.length ? $tut('tut.next') : $tut('tut.tourDone')"
      :mentor-icon="mentorIcon"
      :portrait="tutPortrait"
      @next="nextStop"
      @skip="skipTour"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import TutorialSpotlight from '@/components/tutorial/TutorialSpotlight';
import { waitReward } from '@/components/tutorial/flow';
import { mentorIcon, mentorPortrait } from '@/components/tutorial/mentor';

// Остановки экскурсии: селектор пункта меню + что о нём сказать. Экскурсия ТОЛЬКО называет разделы,
// механикам не учит (иначе новичок читает 15 минут до первой партии).
// 🔴 Остановки про ПРОФИЛЬ здесь НЕТ: о нём рассказывает следующий шаг (`profile_open`) — там же
// и просьба зайти. Иначе игрок читал два диалога подряд про одну кнопку (фидбек оунера 2026-07-30).
const TOUR = [
  { target: '[data-tut="pvp"]', title: 'menu.pvp', text: 'tut.tourPvp' },
  { target: '[data-tut="tournaments"]', title: 'menu.tournaments', text: 'tut.tourTournaments' },
  { target: '[data-tut="learn"]', title: 'tut.buttonActive', text: 'tut.tourLearn' },
];

export default {
  name: 'MainMenu',
  components: { TutorialSpotlight },
  data() {
    return { TOUR, tourIndex: 0, tourStarted: false };
  },
  computed: {
    ...mapGetters(['tutorialButton', 'tutorialStep', 'tutorialHeadStep', 'tutorialActive',
      'tutorialProgress', 'tutorialScreenSteps',
      'dailyBadge', 'tutorialChecklistBadge', 'tutorialActDone']),
    // разделы, которые новичку рано открывать: пока не закрыт Акт 1 (первая победа).
    // Отказавшемуся от обучения (`skipped`) ничего не запираем — принцип «ничего не запираем».
    lockedForNewbie() {
      return this.tutorialActive && !this.tutorialActDone('act1');
    },
    // сколько наград ждут игрока: задания дня + выполненные пункты «Пути новичка».
    // Вход в оба раздела — через профиль, поэтому счётчик висит на нём (фидбек оунера 2026-07-29).
    rewardBadge() { return (this.dailyBadge || 0) + (this.tutorialChecklistBadge || 0); },
    // Раздел заданий живёт за тем же флагом, что и остальной веб-клиент (Pack/колесо/рынок).
    webClientEnabled() { return process.env.VUE_APP_ENABLE_WEB_CLIENT === 'true'; },
    tutorialLabel() {
      if (this.tutorialButton === 'help') return this.$tut('tut.buttonHelp');
      return this.$t(this.tutorialButton === 'resume' ? 'tut.buttonResume' : 'tut.buttonActive');
    },
    tutorialSub() {
      const p = this.tutorialProgress;
      return p ? this.$tut('tut.stepOf', { n: Math.min(p.n + 1, p.total), total: p.total }) : '';
    },
    tutPortrait() { return mentorPortrait(this.$store.state.pvp.fraction); },
    mentorIcon() { return mentorIcon(this.$store.state.pvp.fraction); },
    // экскурсия идёт, пока игрок на шаге `tour` и не отказался от обучения
    // шаг «открой профиль»: подсказка живёт в меню, закрывается переходом в профиль
    tutProfileOpen() {
      return this.tutorialActive && this.tutorialStep === 'profile_open' && !this.$store.getters.tutorialBusy;
    },
    // шаг обучения, который рисуется ПРЯМО В МЕНЮ (Акты 3-4); пока открыт ролл награды — молчим
    tutStep() {
      if (!this.tutorialActive || this.$store.getters.tutorialBusy) return null;
      return this.tutorialStep;
    },
    // подпись «Цикл дня · шаг 1 из 4» на карточке наставника
    actCounter() {
      const p = this.tutorialProgress;
      if (!p || !p.act) return '';
      return `${this.$tut('tut.' + p.act)} · ${this.$tut('tut.stepOf', { n: Math.min(p.n + 1, p.total), total: p.total })}`;
    },
    tourStop() {
      if (!this.tourStarted || !this.tutorialActive || this.tutorialStep !== 'tour') return null;
      return TOUR[this.tourIndex] || null;
    },
  },
  watch: {
    // сервер ответил позже монтирования (или игрок вернулся к обучению) — начинаем экскурсию тогда.
    // 🔴 СЛЕДИМ И ЗА ГОЛОВНЫМ ШАГОМ: после «пройти обучение заново» на самом экране `/` подсказок
    // нет (первые шаги живут на `/start`), `tutorialStep` так и остаётся null — на нём одном
    // watcher не срабатывал бы вовсе, и обучение молча не начиналось (баг 2026-08-20).
    tutorialStep: { handler() { this.maybeStart(); }, immediate: false },
    tutorialHeadStep: { handler() { this.maybeStart(); }, immediate: false },
  },
  async mounted() {
    if (this.$store.state.auth.jwt) {
      this.axios.defaults.headers = {
        ...(this.axios.defaults.headers || {}),
        Authorization: `bearer ${this.$store.state.auth.jwt}`,
      };
    }
    if (this.webClientEnabled) {
      this.$store.dispatch('fetchDaily'); // бейдж наград на кнопке «Профиль»
      await this.$store.dispatch('fetchTutorial');
      // 🔴 СНАЧАЛА `maybeStart`, И ЕСЛИ ОН УВЁЛ НА `/start` — БОЛЬШЕ НИЧЕГО НЕ ДЕЛАЕМ: переход роутера
      // асинхронный, и вызванный следом подхват успевал промотать шаги выбора стороны и дара.
      if (this.maybeStart()) return;
    }
  },
  methods: {
    // выбор стороны и дар живут на отдельном экране: если игрок ещё там — уводим туда
    // Вернуть true, если увели на отдельный экран `/start` (выбор стороны/дар) — вызывающий должен
    // остановиться: подхват обучения в этот момент трогать указатель не имеет права.
    // 🔴 СПРАШИВАЕМ ЭКРАН `/start`, А НЕ ТЕКУЩИЙ ШАГ (баг 2026-08-20): в модели «что пройдено»
    // `tutorialStep` — это шаг ТЕКУЩЕГО экрана, а в меню на выборе стороны показывать нечего
    // (шаги `tour`/`profile_open` ждут дара) → он null, и «Пройти обучение заново» приводило
    // игрока в меню, где обучение не начиналось: счётчик шёл, подсказок не было.
    maybeStart() {
      if (!this.tutorialActive) return false;
      const start = this.tutorialScreenSteps('/start');
      if (start.length) { this.$router.replace('/start'); return true; }
      if (this.tutorialStep === 'tour') this.tourStarted = true;
      return false;
    },
    // Шаг закрываем ЗДЕСЬ, а не в профиле: иначе кнопка «Назад» возвращала в меню ту же карточку
    // (профиль подтверждал шаг только после ответа `GET /tutorial`).
    async goProfile() {
      this.$store.dispatch('tutorialStepDone', 'profile_open');
      this.$router.push('/profile');
    },
    async nextStop() {
      if (this.tourIndex + 1 < TOUR.length) { this.tourIndex += 1; return; }
      this.tourStarted = false;
      await this.$store.dispatch('tutorialStepDone', 'tour');
      // дальше — профиль: оттуда открываются все разделы (решение оунера 2026-07-29)
    },
    async skipTour() {
      this.tourStarted = false;
      await this.$store.dispatch('tutorialSkip');
    },
    async onTutorial() {
      if (this.tutorialButton === 'help') { // обучение пройдено — экран «Справка» (темы + перепройти акт)
        this.$router.push('/help');
        return;
      }
      await this.$store.dispatch('tutorialResume');
      this.tourIndex = 0;
      // 🔴 КНОПКА ВЕДЁТ К ГОЛОВНОМУ ШАГУ ЦЕПОЧКИ, а не к шагу текущего экрана: в меню своих шагов
      // может не быть вовсе, а «Продолжить обучение» обязано довести игрока туда, где он встал.
      const step = this.tutorialHeadStep;
      if (step === 'faction' || step === 'gift') { this.$router.push('/start'); return; }
      if (step === 'tour') { this.tourStarted = true; return; }
      if (step === 'equip') { this.$router.push('/pack'); return; }
      // шаги Актов 3-4 живут в своих разделах: кнопка обязана доводить игрока туда сама
      const HOME = { day2_welcome: null, comp_season: null };  // эти рисуются прямо в меню
      const ROUTE = {
        day2_streak: '/daily', day2_wheel: '/wheel',
        comp_ref: '/profile',
      };
      if (step in HOME) return;
      if (ROUTE[step]) { this.$router.push(ROUTE[step]); return; }
      this.$router.push('/pvp'); // шаги партии — играть надо в PvP
    },
    // шаг Акта 3/4 закрыт в меню → уводим игрока на экран следующего шага
    async tutGo(code, route) {
      await this.$store.dispatch('tutorialStepDone', code);
      await waitReward(this.$store);   // сперва награда за шаг, потом следующий раздел
      if (route) this.$router.push(route);
    },
    playMenu() {
      const menu = document.createElement('audio');
      menu.src = '/sounds/menu.mp3';
      menu.play();
    },
  },
};
</script>

<style scoped lang="scss">
  .main-menu{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    &__item{
      position: relative;
      width: 200px;
      padding: 2em;
      background: url("../assets/button.webp") no-repeat;
      background-size: 100% 100%;
      margin-bottom: 1em;
      color: #fff;
      font-weight: 600;
      cursor: pointer;
      text-decoration: none;
      text-transform: uppercase;
      &:hover{
        filter: contrast(150%);
      }
      &-inactive{
        filter: sepia(1) !important;
        cursor: default;
      }
    }
    // подпись под названием пункта (прогресс обучения) — мелкая, не ломает высоту кнопки
    &__soon{
      display: block;
      font-size: 0.62em;
      text-transform: none;
      color: #ffe0a8;
      margin-top: 3px;
      opacity: 0.9;
    }
    // Бейдж «сколько наград ждёт» на пункте «Задания дня» (число заданий/писем к забору)
    &__badge{
      position: absolute;
      top: 0.7em;
      right: 0.9em;
      min-width: 1.6em;
      padding: 0.15em 0.4em;
      border-radius: 1em;
      background: linear-gradient(135deg, #ffd257, #f0a13a);
      color: #4a2f00;
      font-size: 0.72em;
      line-height: 1.3;
      font-weight: 700;
      text-align: center;
    }
  }

  @media (max-width: 720px) {
    .main-menu{
      width: 100%;
      box-sizing: border-box;
      // margin:auto центрирует меню по вертикали (перебивает align-items:flex-start у .wrapper).
      // Меню короткое → влезает под экран → auto-margin делит свободное место сверху/снизу.
      // Горизонтально margin:auto = 0 (width:100%), прежний оверфлоу не вернётся.
      margin: auto;
      // расширяем верх/низ рамки (было 16px у .card) — больше воздуха над первым и под последним пунктом
      padding: 44px 16px;
      // рамка выше (~+50%): фиксируем высоту фрейма, кнопки центрируются внутри (justify-content:center)
      min-height: 60vh;
      &__item{
        box-sizing: border-box;
        width: 100%;
        max-width: 256px;     // −20% от 320 (просьба оунера)
        padding: 1.1em 1em;   // ниже, чем 2em — больше пунктов влезает без скролла
        font-size: 1.05em;
      }
    }
  }
</style>
